import RequsetApI from '@/js/request/requsetApI.js';
import AuthUtil from './unit/AuthUtil.js';
import {getCookie, setSecureTokenCookie, deleteCookie} from '@/js/utils/CookieUtil';
/**
 * 가독성 목적으로.. 사용했습니다.
 * 절대 stateValue를 직접 변경하지말아주세요.
 */


//갱신주기(초)
const _USER_INFO_SYNC_TIME = 10;

export default {
    //하나의 store안에서 모듈화되어 사용될 수 있음을 명시
    namespaced : true,
    // 실제로 취급해야하는 각각의 data(==data)
    state: {
      auth : null, //권한
      user : null,//사용자 정보
      token : ''
    },
    
    // 계산된 상태를 만들어내는 개념(==computed)
    getters: {
      getAuthList(state) {
        return state.auth;
      },

      getUserInfo(state) {
        return state.user;
      },

      getUserId(state) {
        return state.user?.userId;
      },

      getUserName(state) {
        // 서버 조회 결과인 store 데이터에서만 사용자명 반환
        return state.user?.name || '';
      },

      getToken(state) {
        // store에 토큰이 없으면 쿠키에서 반환 (state 변경 없이)
        if (!state.token || state.token === '') {
          const savedToken = getCookie('access_token');
          if (savedToken) {
            console.log('🔄 Returning token from cookie');
            return savedToken;
          }
        }
        return state.token;
      }
    },
    

    //✅mutations를 통에서만 데이터를 변경할 수 있습니다.
    mutations: {
      initSyncUserInfo(state) {
        const userId = state.user?.userId;
        if (userId) {
          RequsetApI.findUserInfo({}, (res1) => {
            if ( res1.data.results.length > 0 ) {
              state.user = res1.data.results[0];
              RequsetApI.selectAuthJoin({grpMgrSeq:res1.data.results[0].authGrpSeq}, (res) => {
                state.auth = res.data.results;
              });
            }
          });
        }
      },

      setAuthList(state, data) {
        console.log('===================================================== setAuthList', data);
        state.auth = data;
      },

      setUserInfo(state, data) {
        state.user = data;
        // user_id만 쿠키에 저장 (사용자명은 서버 조회 결과로만 표시)
        if (data && data.userId) {
          setSecureTokenCookie('user_id', data.userId, false);
        } else {
          deleteCookie('user_id');
        }
      },

      setToken(state, data) {
        state.token = data;
        // 보안 쿠키에 저장하여 새로고침 시 복원 가능하도록 함
        if (data && data !== '') {
          setSecureTokenCookie('access_token', data, false); // access token
        } else {
          deleteCookie('access_token');
        }
      },

      clearToken(state) {
        state.token = '';
        deleteCookie('access_token');
      },

      restoreToken(state) {
        const savedToken = getCookie('access_token');
        if (savedToken && (!state.token || state.token === '')) {
          console.log('🔄 Restoring token from cookie to store');
          state.token = savedToken;
        }
      },

      clearUserData(state) {
        state.user = null;
        state.auth = null;
        state.token = '';
        deleteCookie('access_token');
        deleteCookie('user_id');
      }
    }, 

    //actions의 함수들은 비동기로만 동작
    //✅async, await를 붙이지 않아도 비동기로만동작한다.
    actions: {
      initSyncUserInfo({ commit }, payload) {
        commit('initSyncUserInfo', payload);
        setInterval(() => {
          commit('initSyncUserInfo', payload);
        }, _USER_INFO_SYNC_TIME * 1000 ); // 1초마다 상태를 증가시키는 예제

      
      },

      async chkUrlAuth(context, payload) {
        // state.auth를 이용한 권한 체크
        const isAuthorized = await AuthUtil.chkUrlAsyncOrg(context.state.auth, payload);
     
        return isAuthorized;
      },

      setAuthList({ commit }, payload) {
        commit('setAuthList', payload);
      },
      
      setUserInfo({commit}, payload) {
        commit('setUserInfo', payload);
      },
     
      setToken({commit}, payload) {
        commit('setToken', payload);
      },

      clearToken({commit}) {
        commit('clearToken');
      },

      clearUserData({commit}) {
        commit('clearUserData');
      },

      restoreToken({commit}) {
        commit('restoreToken');
      },

      setJustLoggedIn({commit}, value) {
        commit('setJustLoggedIn', value);
      },

      // 새로고침 시 user_id로 사용자 정보와 권한 정보 복원
      async restoreUserData({commit}) {
        const savedUserId = getCookie('user_id');
        const savedToken = getCookie('access_token');
        
        if (savedUserId && savedToken) {
          console.log('🔄 Restoring user data for userId:', savedUserId);
          
          try {
            // 토큰 복원
            commit('restoreToken');
            
            // 사용자 정보 조회
            const userInfoResult = await new Promise((resolve) => {
              RequsetApI.findUserInfo({}, (res) => {
                resolve(res);
              });
            });
            
            if (userInfoResult.data.results.length > 0) {
              const userInfo = userInfoResult.data.results[0];
              commit('setUserInfo', userInfo);
              
              // 권한 정보 조회
              const authResult = await new Promise((resolve) => {
                RequsetApI.selectAuthJoin({grpMgrSeq: userInfo.authGrpSeq}, (res) => {
                  resolve(res);
                });
              });
              
              if (authResult.data.results) {
                commit('setAuthList', authResult.data.results);
                console.log('✅ User data and auth restored successfully');
                return true;
              }
            }
          } catch (error) {
            console.error('❌ Failed to restore user data:', error);
            // 복원 실패 시 모든 데이터 정리
            commit('clearUserData');
            return false;
          }
        }
        
        return false;
      }
    }
    
  }